var map = {
	"./banners/de_main-image.json": [
		"./src/themes/default/resource/banners/de_main-image.json",
		"vsf-head-img-banners-de_main-image-json"
	],
	"./banners/de_promoted_offers.json": [
		"./src/themes/default/resource/banners/de_promoted_offers.json",
		"vsf-head-img-banners-de_promoted_offers-json"
	],
	"./banners/it_main-image.json": [
		"./src/themes/default/resource/banners/it_main-image.json",
		"vsf-head-img-banners-it_main-image-json"
	],
	"./banners/it_promoted_offers.json": [
		"./src/themes/default/resource/banners/it_promoted_offers.json",
		"vsf-head-img-banners-it_promoted_offers-json"
	],
	"./main-image.json": [
		"./src/themes/default/resource/main-image.json",
		"vsf-head-img-main-image-json"
	],
	"./promoted_offers.json": [
		"./src/themes/default/resource/promoted_offers.json",
		"vsf-head-img-promoted_offers-json"
	],
	"./slider.json": [
		"./src/themes/default/resource/slider.json",
		"vsf-head-img-slider-json"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 3);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./node_modules/@vue-storefront/theme-default/resource lazy recursive ^\\.\\/.*\\.json$";
module.exports = webpackAsyncContext;